import { AnimatePresence, motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { addBackToTop } from 'vanilla-back-to-top'

import { getStudentLessons } from '@/api/center'
import picEmpty from '@/assets/images/pic_empty.png'
import ClassItem from '@/components/ClassItem'
import ImgPlaceholder from '@/components/ImgPlaceholder'
import Loadding from '@/components/Loadding'
import Title from '@/components/Title'

import TimeBar from './components/TimeBar'

export default function Index() {
  const [date, setDate] = useState('')
  const [lessons, setLessons] = useState<any[]>([])
  const navigate = useNavigate()

  useEffect(() => {
    const toTop: any = document.querySelector('#back-to-top')
    if (!toTop) {
      addBackToTop({
        backgroundColor: '#FFF',
        cornerOffset: 20, // px
        diameter: 56, // px
        // ease: inOutSine, // any one from https://www.npmjs.com/package/ease-component will do
        id: 'back-to-top',
        innerHTML: '<svg color="#333" viewBox="0 0 24 24"><path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"></path></svg>',
        onClickScrollTo: 0, // px
        scrollContainer: document.body, // or a DOM element, e.g., document.getElementById('content')
        scrollDuration: 250, // ms
        showWhenScrollTopIs: 500, // px
        // size: diameter, // alias for diameter
        textColor: '#fff',
        zIndex: 1
      })
    }
  }, [])

  const { isFetching, data } = useQuery(['getStudentLessons', date], (props) => {
    if (props.queryKey[1]) {
      return getStudentLessons({
        userId: localStorage.userid,
        date: props.queryKey[1],
        uniqueDeviceNo: localStorage.visitorId
      })
    }
  })

  useEffect(() => {
    if (data && data.status === 0) {
      setLessons(data.data)
    }
  }, [data])

  const change = (t: string) => {
    setDate(t)
  }

  return (
    <Container initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.98 }} className="relative">
      <Title title="我的课表" />
      <Card className="p-[20px] flex justify-center items-start mb-[10px]">
        <TimeBar onChange={change} />
      </Card>
      <Loadding state={isFetching}>
        <AnimatePresence exitBeforeEnter>
          {lessons.length ? (
            lessons.map((item, i) => (
              <Card
                key={item.id}
                initial={{ y: 10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: i / 20 }}
                className="flex justify-center items-start p-[20px] mb-[20px]"
              >
                <ClassItem data={item} />
              </Card>
            ))
          ) : (
            <Card initial={{ y: 10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="flex justify-center items-start p-[20px] mb-[20px]">
              <div className="w-full h-full flex items-center justify-center flex-col">
                <ImgPlaceholder className="w-[100px]" src={picEmpty} />
                <span className="text-[14px] text-[#999]">暂无数据</span>
              </div>
            </Card>
          )}
        </AnimatePresence>
      </Loadding>
    </Container>
  )
}

const Container = styled(motion.div)`
  .class-modal {
    width: 500px;
    padding: 0 0 20px 0;
    border-radius: 0;
  }
`
const Card = styled(motion.div)`
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  background-color: #fff;
  border-radius: 6px;
  .btn-style {
    background: linear-gradient(39deg, #ff742f 0%, #ff3300 100%);
  }
`
